import React, { useState, useEffect } from 'react'
import axios from 'axios';

import { url_root } from '../config'; // Importiere die Konfigurationsdaten

import '../components/PopupDatasheet.css'
import './new_pages.css'


function YarnNew({ 
  closeNewPopup, 
  fields, 
  sortedManufacturerOptions, 
  sortedBaseMaterialOptions, 
  formatTimestampNow, 
  sortedStructureOptions, 
  sortedCoatingMaterialOptions, 
  sortedInstitutionOptions, 
  sortedDatasheetOptions, 
  sortedPictureOptions, 
  sortedTextileWeightUnitOptions, 
  sortedDiameterUnitOptions, 
  sortedFlexibilityUnitOptions, 
  sortedSelfHeatingUnitOptions,
  sortedElectricalResistivityUnitOptions, 
  sortedMaxTemperatureUnitOptions,
  sortedCoatedUnitOptions, 
  sortedCoatedStabilityUnitOptions, 
  fetchYarnAll, 
  updateCurrentInstitutionName,
  copiedData, 
  newSaveID,
  convertCommaToDotForFloatFields,
  setDefaultForEmptyNumberFields,
  handleFocus,
  handleBlur,
  validateField,
  setErrors,
  errors,
  setErrorMessage,
  setShowErrorModal,
  handleDatasheetChangeAndUpload,
  handlePictureChangeAndUpload,
  fetchYarnImageOptions,
  fetchYarnDatasheetOptions
}) {
    const id_institution = window.localStorage.getItem('id_institution');
    const id_role = window.localStorage.getItem('id_role');

    const access_token = window.localStorage.getItem('access_token');
                      
    const [post, setPost] = useState({
      id_yarn: '',
      name: '',
      manufacturer_name: '',
      institution_name: '',
      diameter: '',
      unit_diameter_name: '',
      yarn_fineness: '',
      unit_yarn_fineness_name: '',
      material_name: '',
      material_own: '',
      structure_name: '',
      electrical_resistivity: '',
      unit_electrical_resistivity_name: '',
      washability_cycles: '',
      uv_resistance: '',
      flexibility: '',
      unit_flexibility_name: '',
      self_heating: '',
      unit_self_heating_name: '',
      change_flexibility: '',
      material_coated_name: '',
      material_coated_own: '',
      coating_structure: '',
      coating_adhesion: '',
      unit_coating_adhesion_name: '',
      change_coating_adhesion: '',
      coating_stability: '',
      unit_coating_stability_name: '',
      max_temperature: '',
      unit_max_temperature_name: '',   
      datasheet:'',
      filename:'',
      others: '',
      all_can_read: false, // checkbox mit boolean-Wert initialisieren
      timestamp: '',
    });

  
    useEffect(() => {
      // Wenn kopierter Datensatz vorhanden ist, setze ihn in den Zustand
      if (copiedData) {
        setPost(copiedData);
      }
    }, [copiedData]);


    // useEffect wird ausgefuehrt, wenn der institution_name im dropdown geaendert wird
    useEffect(() => {
      if (post.institution_name) {
        // Funktionen zur Ausgabe der Datenblaetter bzw. Bilder fuer ausgewaehlte Institution
        fetchYarnDatasheetOptions(post.institution_name);
        fetchYarnImageOptions(post.institution_name);
        updateCurrentInstitutionName(post.institution_name);
      }
    }, [post.institution_name]);


    const handleInput = (event) => {
      const { name, value, type, checked } = event.target;
          
      // Update the post state with the selected value
      setPost(prevPost => ({
        ...prevPost,
        [name]: type === 'checkbox' ? checked : value,
      }));
  
      // Remove the error message once a valid selection is made
      if (errors[name]) {
        setErrors(prevErrors => ({
          ...prevErrors,
          [name]: null,
        }));
      }
    };


    // Funktion zum Speichern eines neuen Garns
    const handleNewSave = async () => {
      let newErrors = {};
      try {
        // Schritt 1: Alle Felder auf Leerwert pruefen und Fehler sammeln
        fields.forEach((field) => {
          const value = String(post[field.name] || ''); // Standardwert auf leer setzen, falls undefined
          const rules = field.validate || {};
          
          // Validierung aufrufen und Fehler im neuen Fehlerobjekt speichern
          const error = validateField(field.name, value, rules, (errorObj) => {
            newErrors = { ...newErrors, ...errorObj };
          });
          
          if (error) {
            newErrors[field.name] = error;
          }
        });

        // Schritt 2: Fehler im Zustand speichern
        setErrors(newErrors);

        // Schritt 3: Ueberprüfen, ob Fehler vorhanden sind
        const hasErrors = Object.values(newErrors).some((error) => error !== '');

        if (hasErrors) {
          // Zeige das Modal, wenn noch Fehler vorhanden sind
          setErrorMessage("Bitte korrigieren Sie die fehlerhaften Felder, bevor Sie speichern.");
          setShowErrorModal(true);
          return; // Stoppe das Speichern, bis die Fehler behoben sind
        }

        // Fehler zuruecksetzen, falls alles korrekt ist
        setErrors({});

        const timestamp = formatTimestampNow(); // Aktuellen Zeitstempel abrufen und formatieren
        const newPost = { ...post, id_institution, timestamp }; // Zeitstempel zum neuen Eintrag hinzufügen

        // Setze leere Float- und Integer-Felder auf -123
        setDefaultForEmptyNumberFields(newPost, fields);
        // Konvertiere Komma in Punkt nur bei Feldern mit { float: true }
        convertCommaToDotForFloatFields(newPost, fields);

        const response = await axios.post(`${url_root}/new_knit_yarn`, newPost,
          {
            headers: {
                'Authorization': `Bearer ${access_token}`
            }
          }
        );

        // Ueberpruefen des Statuscodes in der API-Antwort
        const statusCode = response.status;
        if (statusCode === 252) {
          setErrorMessage("Diese Bezeichnung für Funktionsgarn ist schon vergeben.");
          setShowErrorModal(true);
          return;
        } else if (statusCode === 251) {
          setErrorMessage("Bitte geben Sie eine Bezeichnung ein.");
          setShowErrorModal(true);
          return;
        }

        const id_yarn = response.data.id_yarn
        fetchYarnAll(); // Tabelle aktualisieren       
        // Aufruf Funktion zur Weitergabe der id an die YarnPage, danach an BasicTable, um den neuen Datensatz zu markieren
        newSaveID(id_yarn); 
        closeNewPopup(); // Popup für neue Eintrage schließen
      } catch (error) {
        console.error('Fehler beim Speichern des neuen Eintrags:', error);
      }
    };
  

  return (
    <div className='new-popup-page'>
      <div className='new-title'>
        <h3>Hier können Sie ein neues Funktionsgarn anlegen:</h3>
      </div>

      {id_role == 1 && (
        <div className="new-input-row">
          <label>Institution</label>
          <div className="new-input-with-unit">

            {/* bei Aenderung der Institution werden nur die Bilder u. Datenblaetter dieser Institution angezeigt */}
            <select 
              onChange={(e) => {
                // hier wird der ausgewählte institution_name des Dropdown-Menues in Variable gespeichert
                const selectedInstitution = e.target.value; 
                // ...prevPost sorgt dafür, dass alle anderen Daten im post-Objekt erhalten bleiben 
                // und nur institution_name neu gesetzt wird
                setPost(prevPost => ({
                  ...prevPost,  
                  // institution_name wird geaendert, useEffect dadurch ausgeloest 
                  // Aufruf: fetchMachineconfigurationOptions fetchBasicYarnOptions und fetchYarnOptions
                  institution_name: selectedInstitution, 
                  // Setzt die Dropdown-Felder zurueck, damit die alte Auswahl raus ist
                  datasheet: '',
                  filename: ''
                }));
              }} 
              name="institution_name" 
              value={post.institution_name}
              onFocus={(event) => handleFocus(event, setErrors)}
              // Manuelle Validierung für institution_name aufrufen
              onBlur={(e) => {const value = e.target.value;
                // Wenn das Feld leer ist, setze eine Fehlermeldung
                if (!value) {
                  setErrors(prevErrors => ({
                    ...prevErrors,
                    institution_name: "Bitte wählen Sie eine Institution."
                  }));
                } else {
                  // Entferne den Fehler, wenn eine Institution ausgewaehlt ist
                  setErrors(prevErrors => ({
                    ...prevErrors,
                    institution_name: ''
                }));
              }
            }}         
            >
                              
              <option value=""></option>
              {sortedInstitutionOptions.map((option, index) => (              
                <option key={index} value={option}>
                  {option}
                </option>
              ))}
            </select>
            {/* Fehlernachricht für institution_name anzeigen */}
            {errors.institution_name && (
              <span className="error-message">{errors.institution_name}</span>
            )}
          </div>
        </div>
      )}

      {fields.map(field => {
        const fieldValue = post[field.name];
        // Setze den Wert auf einen leeren String, wenn er kleiner oder gleich 0 ist
        const displayValue = fieldValue < 0 ? '' : fieldValue;

        return (
        <div key={field.name} className="new-input-row">
          <label className={field.label.trim() === '' ? 'empty' : ''}>{field.label}</label>

          <div className="new-input-with-unit">
          {field.type === 'select' ? (
          <>
          <select 
            onChange={handleInput} 
            name={field.name} 
            value={displayValue}
            onFocus={(event) => handleFocus(event, setErrors)}
            onBlur={(event) => handleBlur(event, fields, {}, (name, value, rules) => 
              validateField(name, value, rules, setErrors))}
          >
              <option value=""></option>
              {field.name === 'manufacturer_name' && sortedManufacturerOptions.length > 0 ? (
                sortedManufacturerOptions.map((option, index) => (              
                  <option key={index} value={option}>
                    {option}
                  </option>
              ))
              ) : field.name === 'material_name' && sortedBaseMaterialOptions.length > 0 ? (
                sortedBaseMaterialOptions.map((option, index) => (              
                  <option key={index} value={option}>
                    {option}
                  </option>
              ))
              ) : field.name === 'structure_name' && sortedStructureOptions.length > 0 ? (
                sortedStructureOptions.map((option, index) => (              
                  <option key={index} value={option}>
                    {option}
                  </option>
              ))
              ) : field.name === 'material_coated_name' && sortedCoatingMaterialOptions.length > 0 ? (
                sortedCoatingMaterialOptions.map((option, index) => (              
                  <option key={index} value={option}>
                    {option}
                  </option>
              ))
              ) : field.name === 'datasheet' ? (
                  sortedDatasheetOptions.length > 0 &&
                  sortedDatasheetOptions
                  .filter(option => option !== "") // Filtere leere Optionen heraus
                  .map((option, index) => (
                      <option key={index} value={option}>
                      {option}
                      </option>
              ))
              ) : field.name === 'filename' ? (
                  sortedPictureOptions.length > 0 &&
                  sortedPictureOptions
                  .filter(option => option !== "") // Filtere leere Optionen heraus
                  .map((option, index) => (
                      <option key={index} value={option}>
                      {option}
                      </option>
              ))
            ) : null}
          </select>
            {/* Fehlernachricht für das aktuelle select-Feld anzeigen */}
            {errors[field.name] && (
              <span className="error-message">{errors[field.name]}</span>
            )}
          </>

            ) : field.type === 'checkbox' ? (
              <div className="new-input-row-checkbox">
                <input 
                  type="checkbox"
                  name={field.name}
                  checked={post[field.name]}
                  onChange={handleInput}
                />
              </div>
            ) : field.type === 'picture_button_group' ? ( 
              <div className='button-group'>
                <input
                  type="file"
                  id="fileInput4"
                  style={{ display: 'none' }} // Versteckt den eigentlichen Datei-Input
                  onChange={handlePictureChangeAndUpload} // Event-Handler für Datei-Auswahl und Upload
                />
                <button
                  type="button"
                  className="custom-button"
                  onClick={() => document.getElementById('fileInput4').click()} // Oeffnet den Datei-Dialog
                >
                  Bild auswählen und hochladen
                </button>
              </div>

            ) : field.type === 'datasheet_button_group' ? (
              <div className='button_group'>
                <input
                  type="file"
                  id="fileInput3"
                  style={{ display: 'none' }} // Versteckt den eigentlichen Datei-Input
                  onChange={handleDatasheetChangeAndUpload} // Event-Handler für Datei-Auswahl und Upload
                />
                <button
                  type="button"
                  className="custom-button"
                  onClick={() => document.getElementById('fileInput3').click()} // Oeffnet den Datei-Dialog
                >
                  Datenblatt auswählen und hochladen
                </button>
              </div>
          
            ) : field.type === 'textarea' ? (
              <textarea className='textarea'
                name={field.name}
                value={displayValue}
                onChange={handleInput}
              />
            ) : (
            // Datensätze des zu aendernden Datensatzes werden in Texteingabefelder eingetragen
              <>
                <input
                  type={field.type}
                  name={field.name}
                  value={displayValue}
                  onChange={handleInput}

                  onFocus={(event) => handleFocus(event, setErrors)}
                  onBlur={(event) => handleBlur(event, fields, {}, (name, value, rules) => 
                    validateField(name, value, rules, setErrors))}    
                />
                  {errors[field.name] && <span className="error-message">{errors[field.name]}</span>}

                  {field.unit && (                  
                    <div>
                      <select
                        className="new-unit-dropdown"
                        name={field.unit}
                        value={post[field.unit]}
                        onChange={handleInput}
                      >
                        
                        <option value="" disabled> </option>
                        
                        {field.unit === 'unit_diameter_name' && sortedDatasheetOptions.length > 0 ? (
                          sortedDiameterUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                        ))
                        ) : field.unit === 'unit_yarn_fineness_name' && sortedTextileWeightUnitOptions.length > 0 ? (
                          sortedTextileWeightUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                        ))
                        ) : field.unit === 'unit_flexibility_name' && sortedFlexibilityUnitOptions.length > 0 ? (
                          sortedFlexibilityUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                        ))
                        ) : field.unit === 'unit_self_heating_name' && sortedSelfHeatingUnitOptions.length > 0 ? (
                          sortedSelfHeatingUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                        ))
                        ) : field.unit === 'unit_electrical_resistivity_name' && sortedElectricalResistivityUnitOptions.length > 0 ? (
                          sortedElectricalResistivityUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                        ))
                        ) : field.unit === 'unit_max_temperature_name' && sortedMaxTemperatureUnitOptions.length > 0 ? (
                          sortedMaxTemperatureUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                        ))
                        ) : field.unit === 'unit_coating_adhesion_name' && sortedCoatedUnitOptions.length > 0 ? (
                          sortedCoatedUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                        ))
                        ) : field.unit === 'unit_coating_stability_name' && sortedCoatedStabilityUnitOptions.length > 0 ? (
                          sortedCoatedStabilityUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                        ))
                        ) : field.unit === 'unit_max_temperature_name' && sortedMaxTemperatureUnitOptions.length > 0 ? (
                          sortedMaxTemperatureUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                        ))
                        ) : null}
                      </select>
                    
                    </div>   
                  )}
                </>
              )}
            </div>
          </div>
        );
      })}

      <div className='new-input-save-cancel'>
        <button onClick={() => closeNewPopup()}>ABBRECHEN</button> 
        <button onClick={() => handleNewSave()}>SPEICHERN</button>       
      </div>
    </div>
  )
}

export default YarnNew
